import {
  Content,
  ContentAccessUser,
  ContentNode,
  ContentWorkflow,
  UserProfile,
  UserType,
  WorkflowState,
} from '@amzn/awscat-pattern-library-service-model';
import * as UtilApi from '../../api/UtilsApi';
import { getTemplateSections } from './ConverterUtils';

// @ts-expect-error TS7031 - strict migration
export const isAuthorOrCoAuthor = ({ userProfile, coAuthors, contentOwner, workflow }) => {
  const { userId } = userProfile;
  const ownerId = contentOwner
    ? contentOwner.userId
    : workflow.ownerProfile && workflow.ownerProfile.userId;
  return (
    // @ts-expect-error TS7006 - strict migration
    userId === ownerId || (coAuthors && coAuthors.some((coAuthor) => coAuthor.userId === userId))
  );
};

export const isInPeerReview = (workflow: ContentWorkflow | undefined) => {
  return workflow?.draftState
    ? [WorkflowState.IN_REVIEW, WorkflowState.PENDING_REVIEW].includes(workflow?.draftState)
    : false;
};

export const isPeerReviewerOrTechWriter = (
  userProfile: UserProfile,
  peerReviewers: ContentAccessUser[],
): boolean => {
  const peerReviewerIds = (peerReviewers || []).map((pr) => pr.userId);
  const { isTechWriter, isPeerReviewer } = UtilApi.getUserRoles(userProfile, { peerReviewerIds });
  // @ts-expect-error TS2322 - strict migration
  return isTechWriter || isPeerReviewer;
};

export const isAllowedToSeeAppSecLink = (
  userProfile: UserProfile,
  // @ts-expect-error TS7006 - strict migration
  contentOwner,
  // @ts-expect-error TS7006 - strict migration
  workflow,
  // @ts-expect-error TS7006 - strict migration
  coAuthors,
  peerReviewers: ContentAccessUser[],
): boolean => {
  const ownerId = contentOwner
    ? contentOwner.userId
    : workflow.ownerProfile && workflow.ownerProfile.userId;
  // @ts-expect-error TS7006 - strict migration
  const coAuthorIds = (coAuthors || []).map((ca) => ca.userId);
  const peerReviewerIds = (peerReviewers || []).map((pr) => pr.userId);
  const { isSkateholder, isOwner, isBarRaiser } = UtilApi.getUserRoles(userProfile, {
    ownerId,
    coAuthorIds,
    peerReviewerIds,
  });
  return isSkateholder || isOwner || isBarRaiser;
};

export const isAdminOrTechWriter = (userProfile: UserProfile) => {
  const { isAdmin, isTechWriter } = UtilApi.getUserRoles(userProfile);
  return isAdmin || isTechWriter;
};

export const isDescriptionValid = (description: string) => {
  return description.length > 0 && description.length <= UtilApi.descriptionInputMaxLength;
};

export const isContentValid = (metadataValidationError: any, contentDataValidationError: any) => {
  const metadataValid =
    metadataValidationError &&
    Object.keys(metadataValidationError).every((metadata) =>
      Object.keys(metadataValidationError[metadata]).every(
        (e) => !metadataValidationError[metadata][e],
      ),
    );
  const contentDataValid = !contentDataValidationError;
  return metadataValid && contentDataValid;
};

// Validate selected content peer reviewers. If content is partner owned, enforce at least one AWS peer reviewer.
export const isReviewersValid = (
  reviewers: ContentAccessUser[] = [],
  isPartnerOwned: boolean = false,
) => {
  return (
    reviewers?.length > 0 &&
    (!isPartnerOwned || reviewers.some((rv) => rv?.userType === UserType.AWS))
  );
};

export const isInternalUser = (userProfile: UserProfile) => {
  const { type: userType } = userProfile;
  return userType === UserType.AWS;
};

export const missingRequiredSections = (content: Content): ContentNode[] => {
  const { contentSections } = content.contentData;
  const contentSectionIds = contentSections.map((contentSection) => contentSection.id);
  const templateSections = getTemplateSections(content.contentTypeMetadata.contentSubType);
  const missingSections = templateSections.filter(
    (templateSection) => !contentSectionIds.includes(templateSection.id),
  );
  return missingSections;
};

// Matches all HTML tags
export const htmlTagsRegex = new RegExp('<\/?[^>]+(>|$)', 'gi');
// Matches all empty strings or strings with only spaces
export const emptyOrSpaceOnlyRegex = new RegExp(/^\s*$/);
export const imgTagRegex = new RegExp('<img', 'g');
